import { initFilter } from "./filter/filter";
import { initControl } from "./segment-control/control";

initFilter();
initControl();